<template>
  <div v-if="permission">
    <permission-tooltip
        :permission="hasPermission(permission)"
        :tooltip="{top: true, bottom: false, attach: false}"
    >
      <a @click.prevent="click(url)" :class="{disabled: !hasPermission(permission)}" class="settings-category">
        <v-icon x-large :color="hasPermission(permission) ? `success` : `grey`">{{ icon }}</v-icon>
        <h3>{{ title }}</h3>
        <p class="settings-category__description">{{ description }}</p>
      </a>
    </permission-tooltip>
  </div>
  <div v-else>
    <a :href="url" class="settings-category">
      <v-icon x-large color="success">{{ icon }}</v-icon>
      <h3>{{ title }}</h3>
      <p class="settings-category__description">{{ description }}</p>
    </a>
  </div>
</template>
<style scoped>
.disabled:hover {
  cursor: default;
}

.settings-category {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #333;
  margin: 20px;
}

.settings-category:hover {
  color: #333;
}

.settings-category__description {
  text-align: center;
}
</style>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    url: String,
    icon: String,
    title: String,
    description: String,
    permission: {
      type: [String, Function, Boolean],
      required: false,
      default: () => null,
    },
  },
  computed: {
    ...mapGetters([
      'hasPermission'
    ]),
  },
  methods: {
    click: function (href) {
      if (this.permission && !this.hasPermission(this.permission)) {
        return;
      }
      window.location.href = href;
    }
  }
}
</script>
